import React, { useCallback, useMemo, useState } from 'react';
import { Badge, Col, Row } from 'reactstrap';

const COLLAPSE_THRESHOLD = 100;

const stripHtml = (html = '') =>
  html
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    .replace(/<style[\s\S]*?<\/style>/gi, '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const removeImages = (html = '') => html.replace(/<img\b[^>]*>/gi, '');

export default function Notification({
  notification,
  isRead,
  notificationsMessagesSeen,
}) {
  const [expandedMap, setExpandedMap] = useState({});

  const markAsRead = useCallback(
    (n) => {
      if (notificationsMessagesSeen && !isRead) {
        notificationsMessagesSeen([n]);
      }
    },
    [notificationsMessagesSeen, isRead],
  );

  const sortedNotifications = useMemo(
    () =>
      notification
        ? [...notification].sort((a, b) => {
            const timeA = Number(a.createdAt) || 0;
            const timeB = Number(b.createdAt) || 0;
            return timeB - timeA;
          })
        : [],
    [notification],
  );

  const toggleExpanded = useCallback((key) => {
    setExpandedMap((prev) => ({ ...prev, [key]: !prev[key] }));
  }, []);

  const notifColor = isRead
    ? 'notification-item-read'
    : 'notification-item-unread';

  return (
    <div className="notifications-view">
      {sortedNotifications.map((each, index) => {
        const key = each.id || each.createdAt || index;
        const desc = each.description || '';
        const hasImage = /<img\b/i.test(desc);
        const plainText = stripHtml(desc);
        const isLong = plainText.length > COLLAPSE_THRESHOLD;
        const needsExpand = hasImage || isLong;
        const expanded = !!expandedMap[key];

        const collapsedHtml = removeImages(desc);

        const fullHtml = desc;

        return (
          <Row key={key} className="m-0 notif-container">
            <Col xs={12} className={notifColor}>
              <div className="notification-item-content">
                <div className="d-flex justify-content-between align-items-start">
                  <div className="flex-grow-1">
                    <div className="primary-title">{each.name}</div>
                    <div className="divider" />

                    {needsExpand ? (
                      <>
                        <div
                          className={
                            expanded
                              ? 'notifications-description ql-editor' // ql-editor is important to apply 'quill' styles (imput text styling component from admin site)
                              : 'notifications-description ql-editor notifications-description--clamped'
                          }
                          dangerouslySetInnerHTML={{
                            __html: expanded ? fullHtml : collapsedHtml,
                          }}
                        />
                        <button
                          type="button"
                          className="notif-toggle"
                          onClick={() => toggleExpanded(key)}
                        >
                          {expanded ? 'See Less' : 'See More'}
                        </button>
                      </>
                    ) : (
                      <div
                        className="notifications-description"
                        dangerouslySetInnerHTML={{ __html: fullHtml }}
                      />
                    )}
                  </div>

                  {!isRead && (
                    <Badge
                      color="default"
                      onClick={() => markAsRead(each)}
                      className="d-flex circle ml-2"
                      style={{ cursor: 'pointer' }}
                    >
                      X
                    </Badge>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        );
      })}
    </div>
  );
}
